<template>
  <v-app>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      v-model="rowsSelected"
      :single-select="singleSelect"
      show-select
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [50, 100, 150, 200, -1],
      }"
      class="elevation-1"
      fixed-header
    >
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | formatDate('DD/MM/YYYY') }}
      </template>
      <template v-slot:[`item.prix`]="{ item }">
        <span class="font-weight-bold">
          {{ formatWithCurrency(item.prix, item.symbole) }}
        </span>
      </template>
      <template v-slot:[`item.tva`]="{ item }">
        <span class="font-weight-bold">
          {{ item.tva + ' %' }}
        </span>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <a
          title="Supprimer"
          class="cursor-pointer"
          @click.prevent="deleteRow(item.id)"
        >
          <i class="fa fa-trash font-size-17 text-danger"></i
        ></a>
      </template>
      <template v-slot:top>
        <div class="col-lg-6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            solo
            rounded
            clearable
            label="Search"
            dense
            single-line
            hide-details
            class="shrink w-100"
            @keyup.enter="onSearch"
          ></v-text-field>
          <v-spacer></v-spacer>
        </div>
        <v-divider class="mt-0 mb-0"></v-divider>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
import URL from '@/http/article_stock/catalogue';
export default {
  data() {
    return {
      search: '',
      items: [],
      total: 0,
      page: 1,
      perPage: 100,
      singleSelect: false,
      filterType: null,
      rowsSelected: [],
      idsRowsSelected: [],
      options: {
        itemsPerPage: 100,
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.loadItems();
      },
      deep: true,
    },
    rowsSelected: {
      handler(vals) {
        this.$emit('onSelect', false);
        this.idsRowsSelected = vals.map((val) => val.id);
        this.$emit('onSelect', this.idsRowsSelected.length > 0);
      },
      deep: true,
    },
  },
  computed: {
    currentUrl() {
      if (this.filterType === 'detail') return URL.CATALOGUE_DETAIL;
      else return URL.CATALOGUE;
    },
  },
  methods: {
    setFilter(filterType) {
      this.filterType = filterType;
    },
    deleteRow(id) {
      this.$emit('onRowsDelete', [id]);
    },
    onSearch() {
      this.loadItems();
    },
    loadItems() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.idsRowsSelected = [];
      this.rowsSelected = [];
      window.axios
        .get(this.currentUrl, {
          params: {
            search: this.search,
            sortBy: sortBy.length > 0 ? sortBy[0] : 'id',
            sortDesc: sortDesc.length > 0 ? sortDesc[0] : true,
            page: page,
            perPage: itemsPerPage,
            article: this.$route.params.id,
          },
        })
        .then((resp) => {
          this.items = resp.data.data;
          this.total =
            itemsPerPage === -1 ? resp.data.length : resp.data.meta.total;
        })
        .catch();
    },
  },
  mounted() {
    this.loadItems();
  },
  props: ['headers'],
};
</script>
